/* eslint-disable */

/* jshint maxcomplexity: 6, maxdepth:5 */
(function() {
  'use strict';

  var seoHeight = 0;
  categorySeo();

  $(window).resize(function() {
    $('.category-seo').css('height', '');
    seoHeight = $('.category-seo').height();
    categorySeo();
  });

  function categorySeo() {
    if ($('.category-seo').length > 0) {
      if ($('.category-seo').html().length > 10) {
        $('.category-seo').show();

        seoHeight = $('.category-seo').height();

        if ($('.expand-seo').length === 0) {
          var $categorySeo = $('.category-seo');

          if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            if ($('.category-seo').height() <= 40) {
              $('.category-seo').animate({
                height: seoHeight + 30,
              });
              $categorySeo.animate({
                height: seoHeight + 30,
              });
              $categorySeo.children().addClass('open');
            } else {
              $('.category-seo').animate({
                height: 60,
              });
              $categorySeo.animate({
                height: 60,
              });
              $categorySeo.children().removeClass('open');
            }
          }
        }
      } else {
        $('.category-seo').css('width', '100%');
      }

      // for any links to content at top of page
      $('.product-category p a[href*=#]').click(function(e) {
        e.preventDefault();

        //show seo content
        if ($('.category-seo').height() <= 40) {
          $('.category-seo').animate({
            height: seoHeight + 30,
          });
          $('.expand-seo').animate({
            height: seoHeight + 30,
          });
          $('.expand-seo')
            .children()
            .addClass('open');
        }

        const href = $(this).attr('href');
        const hrefSplit = $(this)
          .attr('href')
          .split('#');

        if (hrefSplit[0].length > 0) {
          window.location.href = href;
        } else {
          scrollToArea(href);
        }
      });
    }
  }
})();

function scrollToArea(href) {
  //scroll down page
  const anchor = `a[href="${href}"]`;

  $('html, body').animate(
    {
      scrollTop: $(anchor).offset().top,
    },
    1000,
  );
}
